import { EntityId } from '@/types/common';
export const queryKeys = {
  announcements: {
    all: ['announcements'] as const,
    detail: (id: EntityId) => ['announcement-detail', id] as const,
    categories: ['announcement-categories'] as const,
  },
  notifications: {
    all: ['notifications'] as const,
    list: (userId?: EntityId) => ['notifications', 'list', userId] as const,
    unreadCount: (userId?: EntityId) => ['notifications', 'unread-count', userId] as const,
    historyRoot: (userId?: EntityId) => ['notifications', 'history', userId] as const,
    history: (userId?: EntityId, page?: number, limit?: number, status?: string, type?: string, date?: string) =>
      ['notifications', 'history', userId, page, limit, status, type, date] as const,
    scoped: (userId?: EntityId) =>
      ({
        listKey: queryKeys.notifications.list(userId),
        unreadCountKey: queryKeys.notifications.unreadCount(userId),
        historyKey: queryKeys.notifications.historyRoot(userId),
      }) as const,
  },
  dashboard: {
    pendingApprovals: (companyId?: EntityId, userId?: EntityId) =>
      ['dashboard', 'pendingApprovals', companyId, userId] as const,
  },
  games: {
    today: (slug: string) => ['games', slug, 'today'] as const,
    stats: (slug: string) => ['games', slug, 'stats'] as const,
    leaderboard: (slug: string, scope: 'company', range: 'daily' | 'all-time') =>
      ['games', slug, 'leaderboard', scope, range] as const,
  },
  subscription: {
    modules: ['subscription', 'modules'] as const,
  },
} as const;
